import { createSelector } from '@reduxjs/toolkit';
import UserRunUtils from '../../../../Utils/UserRunUtils';
import { storeSelector } from '../StoreSelector';

const collectedMoons = createSelector(storeSelector, (state) =>
  [...(state.user.currentUser?.run?.collectedMoons ?? [])].reverse()
);
const remainingMoons = createSelector(storeSelector, (state) => {
  if (!state.user.currentUser?.run) {
    return [];
  }
  return UserRunUtils.remainingMoons(state.user.currentUser.run);
});
const nextMoon = createSelector(storeSelector, (state) => {
  if (!state.user.currentUser?.run) {
    return undefined;
  }
  return UserRunUtils.nextMoon(state.user.currentUser.run);
});

export default {
  collectedMoons,
  remainingMoons,
  nextMoon
};
